/**
 * Currency mapping — resolves the Arabic short symbol for a company based on
 * the country stored on its profile. New Gulf-region countries can be added
 * to the map without touching any page.
 *
 * The lookup is case-insensitive and accepts both English and Arabic country
 * names as they appear across the codebase (Register form uses English keys
 * like "Oman", "Saudi Arabia"; some legacy accounts may hold Arabic values).
 */

const CURRENCY_BY_COUNTRY = {
    // Saudi Arabia
    "saudi arabia": "ر.س",
    "saudi": "ر.س",
    "ksa": "ر.س",
    "السعودية": "ر.س",
    "المملكة العربية السعودية": "ر.س",

    // Oman
    "oman": "ر.ع",
    "sultanate of oman": "ر.ع",
    "عمان": "ر.ع",
    "سلطنة عمان": "ر.ع",

    // UAE
    "uae": "د.إ",
    "united arab emirates": "د.إ",
    "الإمارات": "د.إ",
    "الامارات": "د.إ",
    "الإمارات العربية المتحدة": "د.إ",

    // Kuwait
    "kuwait": "د.ك",
    "الكويت": "د.ك",

    // Bahrain
    "bahrain": "د.ب",
    "البحرين": "د.ب",

    // Qatar
    "qatar": "ر.ق",
    "قطر": "ر.ق",
};

/** Returns the Arabic currency short symbol for the given country (Oman by default). */
export function getCurrency(country) {
    if (!country) return "ر.ع";
    const key = String(country).trim().toLowerCase();
    return CURRENCY_BY_COUNTRY[key] || "ر.ع";
}

/** Formats a numeric amount with the correct currency symbol. */
export function fmtMoney(amount, country) {
    const n = Number(amount || 0);
    return `${n} ${getCurrency(country)}`;
}
